<span class="goback">
    <a href="" class="btn btn-grey-bg">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.224124 8.5555C-0.0747085 8.2456 -0.0747085 7.75479 0.224124 7.44489L6.39555 1.04488C6.70224 0.726837 7.20869 0.717629 7.52674 1.02432C7.84478 1.33101 7.85399 1.83746 7.5473 2.1555L2.68278 7.20019L15.2 7.20019C15.6418 7.20019 16 7.55837 16 8.00019C16 8.44202 15.6418 8.80019 15.2 8.80019L2.68278 8.80019L7.5473 13.8449C7.85399 14.1629 7.84478 14.6694 7.52674 14.9761C7.20869 15.2828 6.70224 15.2735 6.39555 14.9555L0.224124 8.5555Z"
                fill="black" />
        </svg> Go Back
    </a>
</span>
<div class="formwrapper card-bg-white">
    <div class="form-header">
        <h4 class="sec-title">Download Financials of your favourite company</h4>
        <p class="sub-text">Fill out the details below to get the financial reports</p>
    </div>
    <form class="form-innerwrap form-download" [formGroup]="financialForm" action="" method="post">
        <div class="input-group company">
            <label class="form-label">Select a company</label>
            <input type="search" #searchOption (keyup)="search($event)" class="form-control"
                id="search">
            <div class="invalid-feedback" *ngIf="!companyList || companyList.length === 0">
                <p>The company you are trying to access does not exist with us at the moment.</p>
                <span>Please share the details below and our team will update you on this.</span>
            </div>

            <div *ngIf="
            companyList !== undefined &&
            companyList !== null &&
            companyList !== ''
            " class="search-list-wrap" (clickOutside)="companyList = undefined">
                <ul class="search-list">
                    <li *ngFor="let item of companyList" class="search-item" (click)="searchDataValue(item)">
                        <a>{{ item.name }}</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="companyfields groupfields" *ngIf="showDoc">
            <div class="input-group">
                <label class="form-label">Company Name</label>
                <input type="text" formControlName="company_name" class="form-control" id="comp-name" placeholder="XYZ Company">
                <div *ngIf="financialForm.controls.company_name.touched && financialForm.controls.company_name.invalid"
                class="invalid-feedback" role="alert">
                <span *ngIf="financialForm?.controls.company_name.errors?.required">Required Field</span>
              </div>
            </div>
            <div class="input-group">
                <label class="form-label">Website</label>
                <input type="text" formControlName="website" class="form-control" id="website" placeholder="Example.com">
                <div *ngIf="financialForm.controls.website.touched && financialForm.controls.website.invalid"
                class="invalid-feedback" role="alert">
                <span *ngIf="financialForm?.controls.website.errors?.url">Please Enter a valid URL</span>
              </div>
            </div>
            <div class="input-group">
                <label class="form-label">CIN (Optional)</label>
                <input type="text" formControlName="cin" class="form-control" id="cin" placeholder="Enter here">
                <div *ngIf="financialForm.controls.cin.touched && financialForm.controls.cin.invalid"
                class="invalid-feedback" role="alert">
                <span *ngIf="financialForm?.controls.cin?.errors?.minlength">CIN should be 21 letters long.</span>
              </div>
            </div>
        </div>
        <div class="wrap-checkboxFilter" *ngIf="!showDoc">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="balsheet" (change)="onBalanceSheetCheckboxChange()" />
              <label for="balsheet">Balance Sheet</label>
            </div>
          
            <p-multiSelect formControlName="balanceSheet" placeholder="Select Year" 
              [options]="ayList" optionLabel="label" optionValue="value"   (onChange)="onBalanceSheetMultiSelectChange($event)">
            </p-multiSelect>
          </div>
          
          <div class="wrap-checkboxFilter" *ngIf="!showDoc">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="pl" (change)="onProfitLossCheckboxChange()"  />
              <label for="pl">Profit & Loss Statements</label>
            </div>
          
            <p-multiSelect formControlName="profitLossSheet" placeholder="Select Year" 
              [options]="ayList" optionLabel="label" optionValue="value" (onChange)="onProfitLossMultiSelectChange($event)">
            </p-multiSelect>
          </div>
        <div class="wrap-checkboxFilter" *ngIf="!showDoc">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="fs" (change)="onFinancialStatementCheckboxChange()"  />
                <label for="fs" *ngIf="ayList.length > 1">{{ayList.length}} Years Financial Statement </label>
                <label for="fs" *ngIf="ayList.length == 1">Lastest Year Financial Statement </label>
            </div>
        </div>
        <p class="sec-title" *ngIf="!showDoc">You might also be Interested in</p>
        <div class="group-form-check d-flex" style="margin-top: 10px;">
            <div class="form-check" *ngIf="showDoc">
                <input class="form-check-input"  formControlName="company_report" type="checkbox" id="cr" [checked]="isComprehensiveChecked"
                (change)="onComprehensiveChange($event)" />
                <label for="cr">Comprehensive Report </label>
            </div>
            <div class="form-check" *ngIf="!showDoc">
                <input class="form-check-input" formControlName="company_report" type="checkbox" id="cr" [checked]="isComprehensiveChecked"
                (change)="onComprehensiveChange($event)"/>
                <label for="cr">Comprehensive Report of {{company_name}} </label>
            </div>
            <div class="form-check" *ngIf="showReport">
                <input class="form-check-input" formControlName="financial_comparison" type="checkbox" id="fc"  [checked]="isComprehensiveChecked || isFinancialChecked"
                [disabled]="shouldDisableOtherCheckboxes() || disabledFinancial()" (change)="onFinancialComparisonChange($event)"/>
                <label for="fc">Financial Comparison Report of {{company_name}}</label>
            </div>
            <div class="form-check" *ngIf="showReport">
                <input class="form-check-input" formControlName="financial_report" type="checkbox" id="frp" [checked]="isComprehensiveChecked || isFinancialChecked"
                [disabled]="shouldDisableOtherCheckboxes()"
                (change)="onFinancialChange($event)"/>
                <label for="frp">Financial Report of {{company_name}}</label>
            </div>
            <div class="form-check" *ngIf="showReport">
                <input class="form-check-input" type="checkbox"  formControlName="financial_ratio" id="fratio" [checked]="isComprehensiveChecked || isFinancialChecked"
                [disabled]="shouldDisableOtherCheckboxes() || disabledFinancial()" (change)="onFinancialRatioChange($event)"/>
                <label for="fratio">Financial Ratios of {{company_name}}</label>
            </div>
            <div class="form-check" *ngIf="showReport">
                <input class="form-check-input" type="checkbox"   formControlName="revenue_report"  id="revenue" [checked]="isComprehensiveChecked || isFinancialChecked"
                [disabled]="shouldDisableOtherCheckboxes() || disabledFinancial()" (change)="onFinancialRevenueChange($event)"/>
                <label for="frp">Financial Revenue Breakdown Report of {{company_name}}</label>
            </div>
            <div class="form-check" *ngIf="showReport">
                <input class="form-check-input" type="checkbox" id="expense"    formControlName="expense_report"  [checked]="isComprehensiveChecked || isFinancialChecked"
                [disabled]="shouldDisableOtherCheckboxes() || disabledFinancial()" (change)="onFinancialExpenseChange($event)"/>
                <label for="fratio">Financial Expense Breakdown Report of {{company_name}}</label>
            </div>
        </div>
        <div class="groupfields persondetail"  *ngIf="loginEmail == undefined">
            <p class="sec-title">Fill out your Personal Details</p>
            <div class="input-group">
                <label class="form-label">Name</label>
                <input type="text" formControlName="name" class="form-control" id="name" placeholder="name">
                <!-- <div *ngIf="financialForm.controls.name.touched && financialForm.controls.name.invalid"
                class="invalid-feedback" role="alert">
                <span *ngIf="financialForm?.controls.name.errors?.required">Required Field</span>
              </div> -->
            </div>
            <div class="input-group">
                <label class="form-label">Email</label>
                <input type="email" formControlName="email" class="form-control" id="email" placeholder="xyz@kredible.com">
                <!-- <div *ngIf="financialForm.controls.email.touched && financialForm.controls.email.invalid"
                class="invalid-feedback" role="alert">
                <span *ngIf="financialForm?.controls.email.errors?.required">Required Field</span>
              </div> -->
            </div>
            <div class="input-group">
                <label class="form-label">Contact No.</label>
                <input type="phone" formControlName="contact" class="form-control" id="contact" placeholder="Enter here">
                <div *ngIf="financialForm.controls.contact.touched && financialForm.controls.contact.invalid"
                class="invalid-feedback" role="alert">
                <span *ngIf="financialForm?.controls.contact?.errors?.minlength">Contact should be 10 letters long.</span>
                <span *ngIf="financialForm?.controls.contact?.errors?.maxlength">Contact should be 10 letters long.</span>
                <span *ngIf="financialForm?.controls.contact?.errors?.noWhiteSpace">Please remove extra
                    spaces.</span>
                  <span *ngIf="financialForm?.controls.contact?.errors?.numberOnly">Please enter Number only.</span>
              </div>
            </div>
        </div>
        <div class="form-check terms">
            <input class="form-check-input" type="checkbox" formControlName="tc"  id="tc" />
            <label for="tc">I agree to the &nbsp;<a href="/terms-and-conditions" target="_blank">Terms &
                    Conditions</a></label>
                    <div *ngIf="
                    financialForm.controls['tc'].touched &&
                    financialForm.controls['tc'].invalid
                  " class="alert alert-danger form-danger errors" role="alert">
                    <span *ngIf="financialForm?.controls.tc?.errors?.tc">Please agree Terms & Condition.</span>
                  </div>
        </div>
        <div class="note-text" *ngIf="note">
            <p>
                <span>Note:</span> For your convenience, TheKredible has introduced ‘Customized Report' where we deliver
                data as per your requirements. To be precise, our team will go through the entire process: checking
                possibilities of gathering data, the time required to complete the report, and pricing details and will
                revert to your query. After terms and conditions
                are discussed and a price is quoted, TheKredible team will then start working on the report providing
                the
                anticipated timeline.
            </p>
        </div>
        <div class="price-wrap">
            <div class="price">
                <span class="actual">INR {{totalPrice}}</span>
                <span class="original"> INR {{totalPrice * 2}}</span>
            </div>
            <button class="btn btn-dark-blue-bg" [disabled]="!financialForm.valid" (click)="submit()">Add to cart</button>
        </div>
    </form>
</div>